import { TFunction } from 'i18next'

import { BadgeColorKeys } from '@/components/ui/badge'
import { LeaseStatus, UnitOccupancyStatus } from '@/models/features'

const UNIT_STATUS_COLORS: Record<UnitOccupancyStatus, BadgeColorKeys> = {
  Occupied: 'green',
  Vacant: 'blue',
}

const LEASE_STATUS_COLORS: Record<LeaseStatus, BadgeColorKeys> = {
  Applicant: 'blue',
  Current: 'blue',
  Future: 'green',
  Notice: 'purple',
  Past: 'neutral',
}

export const getUnitStatusColor = (status: UnitOccupancyStatus): BadgeColorKeys =>
  UNIT_STATUS_COLORS[status]

export const getLeaseStatusColor = (status: LeaseStatus): BadgeColorKeys =>
  LEASE_STATUS_COLORS[status]

export const getUnitStatusLabel = (status: UnitOccupancyStatus, t: TFunction<['units']>) => {
  const labels: Record<UnitOccupancyStatus, string> = {
    Occupied: t('units:list.tabs.occupied'),
    Vacant: t('units:list.tabs.vacant'),
  }
  return labels[status]
}

export const getLeaseStatusLabel = (status: LeaseStatus, t: TFunction<['units']>) => {
  const labels: Record<LeaseStatus, string> = {
    Applicant: t('units:leaseStatus.applicant'),
    Current: t('units:leaseStatus.current'),
    Future: t('units:leaseStatus.future'),
    Notice: t('units:leaseStatus.notice'),
    Past: t('units:leaseStatus.past'),
  }
  return labels[status]
}
